export default class MatchMedia {
  constructor() {
    this.setup();
  }
  setup() {
    const spBreakpoint = '767px';

    const root = document.documentElement;
    const mql = window.matchMedia('(max-width:' + spBreakpoint + ')');
    mql.addEventListener('change', (e) => {
      if (e.matches) {
        // スマホの場合
        root.classList.remove('view-pc');
        root.classList.add('view-sp');
      } else {
        // PCの場合
        root.classList.remove('view-sp');
        root.classList.add('view-pc');
      }
    });
  }
}
